import React, { useState } from "react";
import { useToast } from "../hooks/use-toast";

const ContactForm = ({
  title = "Send us a message",
  storageKey = "bot_general_contact",
  withAttachments = false,
  buttonText = "Send",
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    const submissions = JSON.parse(localStorage.getItem(storageKey) || "[]");
    submissions.push({
      name,
      email,
      message,
      at: new Date().toISOString(),
    });
    localStorage.setItem(storageKey, JSON.stringify(submissions));
    toast({
      title: "Message received!",
      description: "We'll get back to you shortly.",
    });
    setName("");
    setEmail("");
    setMessage("");
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {title && (
        <h3 className="font-display text-2xl text-[#e8a13a] mb-2">{title}</h3>
      )}
      <div>
        <label className="block text-xs text-[#c8bfae] mb-1 tracking-wider">Name</label>
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="w-full bg-[#181818] border border-[#3a3a3a] px-4 py-3 text-[#f5f1e8] focus:outline-none focus:border-[#e8a13a] transition-colors"
        />
      </div>
      <div>
        <label className="block text-xs text-[#c8bfae] mb-1 tracking-wider">Email *</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-[#181818] border border-[#3a3a3a] px-4 py-3 text-[#f5f1e8] focus:outline-none focus:border-[#e8a13a] transition-colors"
        />
      </div>
      <div>
        <label className="block text-xs text-[#c8bfae] mb-1 tracking-wider">Message</label>
        <textarea
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full bg-[#181818] border border-[#3a3a3a] px-4 py-3 text-[#f5f1e8] focus:outline-none focus:border-[#e8a13a] transition-colors resize-none"
        />
      </div>
      {withAttachments && (
        <div>
          <label className="block text-xs text-[#c8bfae] mb-1 tracking-wider">
            Attach Files
          </label>
          <div className="border border-dashed border-[#3a3a3a] px-4 py-6 text-center text-sm text-[#7d7568]">
            Attachments (0)
          </div>
        </div>
      )}
      <p className="text-[11px] text-[#7d7568] leading-relaxed">
        This site is protected by reCAPTCHA and the Google{" "}
        <span className="underline">Privacy Policy</span> and{" "}
        <span className="underline">Terms of Service</span> apply.
      </p>
      <button
        type="submit"
        className="bg-[#e8a13a] hover:bg-[#d18f28] text-[#0f0f10] font-semibold px-8 py-3 text-sm tracking-widest transition-colors"
      >
        {buttonText}
      </button>
    </form>
  );
};

export default ContactForm;
